import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { OscEnvironment } from '@osc-utils/enums/osc-environments';
import { ConfigurationService } from '@osc-utils/services/configuration.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MobileGuard {
  #router = inject(Router);
  #configurationService = inject(ConfigurationService);

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivateBase();
  }

  public canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivateBase();
  }

  private canActivateBase(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.#configurationService.isMobileApp() || environment.name === OscEnvironment.Simulator
      ? true
      : this.#router.parseUrl('/inspection-requests');
  }
}
